import React, { createContext, useState } from "react";

const PageErrorContext = createContext({
  hasError: false,
  updateError: () => {},
});

const PageErrorContextProvider = ({ children }) => {
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const updateError = (error) => {
    setHasError(error);
    if (error.message) {
      // Update state so the next render will show the fallback UI.
      let message = error.message;
      const errorLines = error.stack?.split("\n").slice(0, 2);
      if (errorLines?.length > 1) {
        // prettier format
        message = `${errorLines[0].trim()} \n ${errorLines[1].trim()}`; // "SomeError: xyz is not defined at ExampleComponent"
      }
      setErrorMessage(message);
    }
  };

  return (
    <PageErrorContext.Provider value={{ hasError, errorMessage, updateError }}>
      {children}
    </PageErrorContext.Provider>
  );
};

export { PageErrorContext, PageErrorContextProvider };
